import styled from "styled-components";

interface FlexProps {
  direction?: string;
  justifyContent?: string;
  flex?: number | string;
  alignItems?: string;
  gap?: string;
  flexWrap?: string;
}

export const Flex = styled.div`
  display: flex;
  flex-direction: ${(props: FlexProps) => props.direction || "row"};
  justify-content: ${(props: FlexProps) => props.justifyContent};
  align-items: ${(props: FlexProps) => props.alignItems};
  flex: ${(props: FlexProps) => (props.flex ? props.flex : "none")};
  gap: ${(props: FlexProps) => props.gap || 0}px;
  flex-wrap: ${(props: FlexProps) => props.flexWrap};
`;
